import React, { forwardRef, useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useSelector, useDispatch } from 'react-redux';
import * as icons from 'react-bootstrap-icons';
import DrawStatusRadios from 'Utils/Helpers/StatusRadios';
import CButton from 'Utils/Helpers/CButton';
import moment from "moment-jalaali";
import DatePickerComponent from 'Utils/Helpers/DatePickerComponent';
import { useSetState } from 'Utils/Helpers/Hooks';
import Inputer from 'Utils/Helpers/Inputer';
import { TextShow } from 'Utils/Helpers/TextShow';
import SelectComponent from 'Utils/Helpers/SelectComponent';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { get_byDate, save_new, update_status } from 'http/components/AppointmentService';
import { enqueueSnackbar } from 'notistack';
import { SetAppointmentsData } from 'Utils/Helpers/HandleApiData';
import DateCheck from 'Utils/Helpers/DateCheck';
import ActionButton from 'Utils/Helpers/ActionButton';
import TimePickerComponent from 'Utils/Helpers/TimePickerComponent';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AppointmentStatusEdit({ id }) {
    const dispatch = useDispatch();
    const { appointments, totalTimes, dateSearch, current, appointmentTypes } = useSelector((state) => ({
        appointments: state.appointments.appointments,
        totalTimes: state.setting.totalTimes,
        dateSearch: state.setting.dateSearch,
        current: state.staff.current,
        appointmentTypes: state.setting.appointmentTypes,
    }));
    const [data, setData] = useState(null);
    const [show, setShow] = useState(false);
    const [value, setValue] = useState(null);
    const [time, setTime] = useState(null);
    const [type, setType] = useState(null);
    const [lastTime, setLastTime] = useState(null);
    const [date, setDate] = useState(moment());
    const [askNeedNextAppointment, setAskNeedNextAppointment] = useState(false);
    const [needNextAppointment, setNeedNextAppointment] = useState(false);
    const [lastParams, setLastParams] = useState(null);
    const [controls, setControls] = useSetState ({
        description: {
          id: "description",
          type: 'text',
          placeholder: 'توضیحات',
          value: '',
          icon: <icons.ChatDots/>,
        },
    });

    useEffect(() => {
        setDate(moment(dateSearch.date, 'jYYYY/jMM/jDD'));
    }, [dateSearch.date])

    const setControlsValue = (name, value) => {
        setControls({ [name]: { value: value } });
    }

    useEffect(() => {
        if(show && appointments && totalTimes) {
            const get_data = appointments.find(item => item.id === id);
            setType(get_data.type)
            setData(get_data);
            try {
                const H = +get_data.time.split('/')[0]
                const M = get_data.time.split('/')[1] ? `/${get_data.time.split('/')[1]}` : '/00'
                setLastTime({H, M, time: `${H.toString().substring(2)}${M.replace('/',':')}`})
                setTime(`${H}${M}`);
            } catch {
                setLastTime(null);
                setTime(`${totalTimes.filter(item => item.status)[0].id}/00`)
            }
        }
    },[id, show, totalTimes, appointments])

    const setShowDialog = () => {
        setAskNeedNextAppointment(false);
        setNeedNextAppointment(false);
        setShow(true);
    }

    const setNeedNextAppointment_mode = async (ans) => {
        if(ans) {
            setNeedNextAppointment(true);
        } else {
            await doLastProcess();
        }
    }

    const handleClose= () => {
        setShow(false);
    }

    const handleChangeTime = (e) => {
        setTime(e)
    }

    const onSelectChange = (e) => {
        setType(e);
    }

    const onSubmit = async () => {
        if(value) {
            let _date = null;
            let _time = null;
            if(value === 1 || value === 2 || value === 3 || value === 6 || value === 7)
                _date = date.locale("fa").format("jYYYY/jMM/jDD");
            if(value === 4 || value === 6 || value === 7)
                _time = time;
            if(!_date || DateCheck(_date)) {
                const params = {
                    id, stid: value, date: _date, time: _time, dow: dateSearch.dow,
                    description: controls.description.value !== '' ? controls.description.value : null,
                }
                if(value === 4) {
                    setAskNeedNextAppointment(true);
                    setLastParams({ params, dateSearch: dateSearch.date })
                } else {
                    dispatch(HandleLoading(true));
                    const response = await update_status(params);
                    if(response.status) {
                        enqueueSnackbar('نوبت با موفقیت ویرایش شد', {variant: 'success'});
                        const response2 = await get_byDate(dateSearch.date);
                        if(response2.status) {
                            await dispatch(SetAppointmentsData(response2.data));
                            handleClose();
                        } else {
                            dispatch(HandleLoading(false));
                        }
                    } else {
                        dispatch(HandleLoading(false));
                    }
                }
            } else {
                enqueueSnackbar('تاریخ انتخاب شده گذشته است', {variant: 'warning'});
                dispatch(HandleLoading(false));
            }
        } else {
            enqueueSnackbar('وضعیت انتخاب نشده است', {variant: 'warning'});
        }
    }

    const doLastProcess = async (new_date) => {
        dispatch(HandleLoading(true));
        const response = await update_status({
            ...lastParams.params,
            description: !new_date ? lastParams.params.description : lastParams.params.description ? lastParams.params.description.concat(' (', `نوبت جدید سریع | تاریخ نوبت بعدی : ${new_date}`, ')') : `نوبت جدید سریع | تاریخ نوبت بعدی : ${new_date}`,
        });
        if(response.status) {
            enqueueSnackbar('نوبت با موفقیت ویرایش شد', {variant: 'success'});
            const response2 = await get_byDate(lastParams.dateSearch);
            if(response2.status) {
                await dispatch(SetAppointmentsData(response2.data));
                handleClose();

            } else {
                dispatch(HandleLoading(false));
            }
        } else {
            dispatch(HandleLoading(false));
        }
    }

    const onSubmitNewAppointment = async () => {
        dispatch(HandleLoading(true));
        const _date = date.locale("fa").format("jYYYY/jMM/jDD");
        if(DateCheck(_date)) {
            await doLastProcess(_date);
            const response = await save_new(_date, dateSearch.dow, type, data.patient_id, `نوبت جدید سریع | تاریخ نوبت قبلی : ${data.date}`);
            if(response.status) {
                enqueueSnackbar('نوبت با موفقیت اضافه شد', {variant: 'success'});
                handleClose();
            } else {
                dispatch(HandleLoading(false));
            }
        } else {
            enqueueSnackbar('تاریخ انتخاب شده گذشته است', {variant: 'warning'});
            dispatch(HandleLoading(false));
        }
    }

    return (
        <>
            <ActionButton
                icon={<icons.ArrowLeftRight/>}
                onClick={setShowDialog}
                disabled={!current[1][0]}
                hidden={!current[1][0]}
            />
            {
                show &&
                <Dialog
                    open={show}
                    fullWidth={true}
                    maxWidth={'xs'}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleClose}
                    aria-describedby="alert-dialog-slide-appointment-edit"
                >
                    <DialogTitle>
                        {askNeedNextAppointment ? 'تنظیم نوبت بعدی' : 'تغییر وضعیت نوبت'}
                        <div className='close-btn' onClick={handleClose}>
                            <icons.X/>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        {
                            data && 
                            <DialogContentText id="alert-dialog-slide-appointment-edit">
                                <div className='appointment-edit'>
                                    <div className='patient'>
                                        <TextShow
                                            title={"نام بیمار :"}
                                            data={data.name}
                                            className={'no-hide text-muted'}
                                        />
                                        <TextShow
                                            title={"تاریخ نوبت :"}
                                            data={data.date}
                                            className={'no-hide text-muted'}
                                        />
                                        {
                                            lastTime &&
                                            <TextShow
                                                title={"ساعت نوبت :"}
                                                data={lastTime.time}
                                                className={'no-hide text-muted'}
                                            />
                                        }
                                        <TextShow
                                            title={"شماره پرونده :"}
                                            data={data.uniCode}
                                            className={'no-hide text-muted'}
                                        />
                                    </div>
                                    {
                                        !askNeedNextAppointment ? (
                                            <>
                                                <div className='change-status'>
                                                    <DrawStatusRadios
                                                        title={'تغییر وضعیت نوبت به :'}
                                                        notZero={true}
                                                        setStatus={setValue}
                                                    />
                                                </div>
                                                <div style={{height: '45px'}}>
                                                    {
                                                        value &&
                                                        (value === 6 || value === 7)
                                                        ? <div className='flex-row-center-center mb-3'>
                                                            <DatePickerComponent
                                                                icon={<icons.Calendar3/>}
                                                                value={date}
                                                                onChange={(e) => setDate(e)}
                                                                className={'ms-1'}
                                                            />
                                                            <TimePickerComponent
                                                                name={'appointment-time'}
                                                                icon={<icons.ClockFill/>}
                                                                options={totalTimes.filter(item => item.status)}
                                                                onChange={handleChangeTime}
                                                            />
                                                        </div>
                                                        : (value === 1 || value === 2 || value === 3)
                                                        ? <div className='change-date'>
                                                            <DatePickerComponent
                                                                icon={<icons.Calendar3/>}
                                                                value={date}
                                                                onChange={(e) => setDate(e)}
                                                            />
                                                        </div>
                                                        : (value === 4)
                                                        ? <div className='change-date'>
                                                            <TimePickerComponent
                                                                name={'appointment-time'}
                                                                icon={<icons.ClockFill/>}
                                                                selectedHour={lastTime ? lastTime.H : null}
                                                                selectedMin={lastTime ? lastTime.M : null}
                                                                options={totalTimes.filter(item => item.status)}
                                                                onChange={handleChangeTime}
                                                            />
                                                        </div>
                                                        : <div className='text-center'>
                                                            <small>
                                                                {"در وضعیت انتخابی امکان تغییر تاریخ یا زمان نمی‌باشد"}
                                                            </small>
                                                        </div>
                                                    }
                                                </div>
                                                <div className='mt-1'>
                                                    {
                                                        Object.keys(controls).map((key, index) => {
                                                            return (
                                                                <Inputer
                                                                    key={`inputer_desc_${controls[key].id}`}
                                                                    id={controls[key].id}
                                                                    type={controls[key].type}
                                                                    placeholder={controls[key].placeholder}
                                                                    value={controls[key].value}
                                                                    setValue={setControlsValue.bind(this)}
                                                                    icon={controls[key].icon}
                                                                    className={'mb-2'}
                                                                />
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </>
                                        ) : (
                                            <div className='mb-3'>
                                                {
                                                    !needNextAppointment ?
                                                    <div>
                                                        <p className='my-2 px-2'>برای بیمار نوبت بعدی لازم هست قرار دهید ؟</p>
                                                        <div className='d-flex flex-row' style={{gap: '5px'}}>
                                                            <CButton
                                                                text={'ذخیره نوبت جدید'}
                                                                // icon={<icons.Save2/>}
                                                                onClick={() => setNeedNextAppointment_mode(true)}
                                                            />
                                                            <CButton
                                                                text={'انصراف'}
                                                                // icon={<icons.X/>}
                                                                onClick={() => setNeedNextAppointment_mode(false)}
                                                                action='secondary'
                                                            />
                                                        </div>
                                                    </div> : 
                                                    <div>
                                                        <p className='mt-2 px-2'>تاریخ و نوع نوبت را انتخاب کنید :</p>
                                                        <div className='change-date'>
                                                            <DatePickerComponent
                                                                icon={<icons.Calendar3/>}
                                                                value={date}
                                                                onChange={(e) => setDate(e)}
                                                                className={'mb-2'}
                                                            />
                                                            <SelectComponent
                                                                name={'app-type'}
                                                                icon={<icons.Fingerprint/>}
                                                                options={appointmentTypes}
                                                                onChange={onSelectChange}
                                                            />
                                                        </div>
                                                        <div className=''>
                                                            <CButton
                                                                text={'ذخیره نوبت جدید'}
                                                                icon={<icons.Save2/>}
                                                                onClick={onSubmitNewAppointment}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    }
                                </div>
                            </DialogContentText>
                        }
                    </DialogContent>
                    {
                        !askNeedNextAppointment &&
                        <DialogActions>
                            <CButton
                                text={'ذخیره تغییرات'}
                                icon={<icons.Save2/>}
                                onClick={onSubmit}
                            />
                        </DialogActions>
                    }
                </Dialog>
            }
        </>
    );
}